/**
 * Production-safe logging utility
 * Prevents console logs from appearing in production environment
 */

// Check if we're in production environment
const isProduction = process.env.NODE_ENV === 'production';

/**
 * Safe console logging that only outputs in non-production environments
 */
const logger = {
  log: (...args) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    if (!isProduction) {
      console.error(...args);
    } else {
      // In production, we could send critical errors to a monitoring service
      // but we don't output them to the console
    }
  },
  
  warn: (...args) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (!isProduction) {
      console.debug(...args);
    }
  },
  
  // For critical errors that should be logged even in production
  // Use this sparingly for truly critical errors that don't expose sensitive data
  critical: (...args) => {
    // Always log critical errors, but sanitize them in production
    if (isProduction) {
      // In production, we could send these to a monitoring service
      // For now, just log a generic message without details
      console.error('A critical error occurred. Check server logs for details.');
    } else {
      console.error('[CRITICAL]', ...args);
    }
  }
};

export default logger;
